module.exports = __webpack_public_path__ + "static/media/SDGIcons_17.bb61ca21.png";